var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentAttatch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0324 3.79745C14.0754 2.84551 12.5228 2.84551 11.5658 3.79745L4.71194 10.6151C3.26269 12.0567 3.26269 14.3929 4.71194 15.8345C6.16266 17.2776 8.51583 17.2776 9.96655 15.8345L16.5224 9.31329C16.7182 9.11855 17.0347 9.11939 17.2295 9.31516C17.4242 9.51094 17.4234 9.82752 17.2276 10.0223L10.6718 16.5435C8.83098 18.3746 5.84752 18.3746 4.00671 16.5435C2.16443 14.711 2.16443 11.7387 4.00671 9.90613L10.8605 3.08848C12.2076 1.7485 14.3906 1.7485 15.7377 3.08848C17.0862 4.42991 17.0862 6.6059 15.7377 7.94733L8.88383 14.765C8.03048 15.6138 6.64801 15.6138 5.79466 14.765C4.93984 13.9147 4.93984 12.535 5.79466 11.6847L11.1585 6.34909C11.3543 6.15435 11.6709 6.15519 11.8656 6.35097C12.0604 6.54674 12.0595 6.86333 11.8638 7.05807L6.4999 12.3936C6.0381 12.853 6.0381 13.5967 6.4999 14.056C6.96316 14.5168 7.71534 14.5168 8.1786 14.056L15.0324 7.23835C15.9879 6.28787 15.9879 4.74793 15.0324 3.79745Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentAttatch);
export default __webpack_public_path__ + "static/media/CommentAttatch.1a22a0298059dbbc7c802b7b4a37f36f.svg";
export { ForwardRef as ReactComponent };